import React, { useState, useContext, useEffect } from "react"
import intl from "react-intl-universal"
import moment from "moment"
import Input from "../../../../../../atoms/Input"
import { fnFormatDateFromUTC } from "../../../../../../../utils/date"
import AuthContext from "../../../../../../../contexts/Auth"
import styles from "./index.module.scss"
import { toast } from "@stardust-ds/react"

const DateFilters = ({
  onChangeDate,
  anlt_cname,
  label,
  nameFilter,
  handleChange,
  selectedDefaultFilter = "all",
  setBcustom,
  justify,
}) => {
  const [currentDateFilterShortcut, setcurrentDateFilterShortcut] = useState()
  const [oCurrentDates, setOCurrentDates] = useState()
  const { oUser } = useContext(AuthContext)

  const [isError, setIsError] = useState(false)

  const cUserTimeZone = oUser?.data?.user_ctimezone

  const DATE_FILTER_SHORTCUTS = [
    {
      label: intl.get("ciq.release_details.date_filters.last_7_days"),
      value: "last_7_days",
    },
    {
      label: intl.get("ciq.release_details.date_filters.last_15_days"),
      value: "last_15_days",
    },
    {
      label: intl.get("ciq.release_details.date_filters.last_30_days"),
      value: "last_30_days",
    },
    {
      label: intl.get("ciq.release_details.date_filters.all"),
      value: "all",
    },
    {
      label: intl.get("ciq.release_details.date_filters.custom"),
      value: "custom",
    },
  ]

  const formateDate = (dDate) => {
    return fnFormatDateFromUTC(dDate, "YYYY-MM-DD", cUserTimeZone)
  }

  const dToday = formateDate(new Date(), cUserTimeZone)

  useEffect(() => {
    const period = JSON.parse(localStorage.getItem(nameFilter))
    const startDate = period?.startDate + "T00:00:00"
    const endDate = period?.endDate + "T00:00:00"

    if (!nameFilter) {
      setcurrentDateFilterShortcut("all")
      return
    }

    if (!localStorage.getItem(nameFilter) && selectedDefaultFilter) {
      setcurrentDateFilterShortcut(selectedDefaultFilter)
      return
    }

    if (
      !localStorage.getItem(nameFilter) ||
      (period?.startDate === "" && period?.endDate === "")
    ) {
      setcurrentDateFilterShortcut("all")
      setBcustom && setBcustom(false)
    } else if (calculateDifferentDays(startDate, endDate) === 30) {
      setcurrentDateFilterShortcut("last_30_days")
      setBcustom && setBcustom(false)
    } else if (calculateDifferentDays(startDate, endDate) === 15) {
      setcurrentDateFilterShortcut("last_15_days")
      setBcustom && setBcustom(false)
    } else if (calculateDifferentDays(startDate, endDate) === 7) {
      setcurrentDateFilterShortcut("last_7_days")
      setBcustom && setBcustom(false)
    } else {
      setcurrentDateFilterShortcut("custom")

      setOCurrentDates(period)
      setBcustom && setBcustom(true)
    }
  }, [anlt_cname])

  const calculateDifferentDays = (data1, data2) => {
    const date1 = new Date(data1)
    const date2 = new Date(data2)

    const differentAtMiliseconds = Math.abs(date1 - date2)

    const milisecondsPerDays = 1000 * 60 * 60 * 24
    const differentDays = Math.ceil(differentAtMiliseconds / milisecondsPerDays)

    return differentDays
  }

  useEffect(() => {
    if (!oCurrentDates) return

    onChangeDate?.(oCurrentDates)
  }, [oCurrentDates])

  const handleDateFilterChange = (dateFilterValue) => {
    setcurrentDateFilterShortcut(dateFilterValue)

    if (dateFilterValue === "custom" && setBcustom) {
      setBcustom(true)
    } else {
      setBcustom && setBcustom(false)
    }

    const dates = {
      last_7_days: {
        startDate: formateDate(moment().subtract(7, "d")),
        endDate: dToday,
      },
      last_15_days: {
        startDate: formateDate(moment().subtract(15, "d")),
        endDate: dToday,
      },
      last_30_days: {
        startDate: formateDate(moment().subtract(30, "d")),
        endDate: dToday,
      },
      all: {
        startDate: "",
        endDate: "",
      },
      custom: {
        startDate: dToday,
        endDate: dToday,
      },
    }

    handleChange && handleChange(dates[dateFilterValue])

    setOCurrentDates(dates[dateFilterValue])
    if (!nameFilter) return
    localStorage.setItem(nameFilter, JSON.stringify(dates[dateFilterValue]))
  }

  const handleOnChangeCustomInitialDate = (e) => {
    const value = e.target.value
    const name = e.target.name
    const startDate = new Date(oCurrentDates.startDate + "T00:00:00")
    const endDate = new Date(value + "T00:00:00")

    if (name === "endDate" && endDate < startDate) {
      setIsError(true)
      return
    }

    const updatedDates = {
      startDate: name === "startDate" ? value : oCurrentDates.startDate,
      endDate: name === "endDate" ? value : oCurrentDates.endDate,
    }

    localStorage.setItem(nameFilter, JSON.stringify(updatedDates))
    setOCurrentDates(updatedDates)

    handleChange(updatedDates)
  }

  useEffect(() => {
    if (isError) {
      toast({
        type: "error",
        title: intl.get("ciq.release_details.date_filters.incorrect_date_format"),
        description: intl.get(
          "ciq.release_details.date_filters.date_final_must_greater_than_or_equal_initial",
        ),
      })

      setIsError(false)

      setOCurrentDates({
        startDate: oCurrentDates.endDate,
        endDate: oCurrentDates.endDate,
      })

      localStorage.setItem(
        nameFilter,
        JSON.stringify({
          startDate: oCurrentDates.endDate,
          endDate: oCurrentDates.endDate,
        }),
      )
    }
  }, [isError === true])

  const isCustom = currentDateFilterShortcut === "custom"

  return (
    <div className={styles.dateFilterWrapper}
      style={{
        alignItems: justify
      }}
    >
      <span
        className={`${styles.dateFilterTitle} ${
          isCustom ? styles.dateFilterTitleWithShortCutCustom : ""
        }`}
      >
        {label}
      </span>
      <div
        className={`${styles.dateFiltersContainer} ${
          currentDateFilterShortcut !== "custom"
            ? styles.dataFilterContainterWithShortCutCustom
            : styles.noPadding
        }`}
      >
        <div className={styles.buttonsContainer}>
          {DATE_FILTER_SHORTCUTS.map(({ label, value }) => (
            <button
              type="button"
              title={label}
              key={value}
              className={`${styles.button} ${
                value === currentDateFilterShortcut && styles.active
              }`}
              onClick={() => handleDateFilterChange(value)}
            >
              {label}
            </button>
          ))}
        </div>
        {isCustom && (
          <div className={styles.dateInputContainer}>
            <Input
              type="date"
              label={intl.get("ciq.release_details.date_filters.initial_date")}
              value={oCurrentDates?.startDate}
              onChange={handleOnChangeCustomInitialDate}
              name="startDate"
              width={150}
            />
            <Input
              type="date"
              label={intl.get("ciq.release_details.date_filters.final_date")}
              name="endDate"
              value={oCurrentDates?.endDate}
              onChange={handleOnChangeCustomInitialDate}
              width={150}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default DateFilters
